var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.865,
    height: 173,
    viewBox: "0 0 188.865 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#d8d8d8;}.c{fill:#4eb0b9;}.d{fill:#4298a0;}.e{fill:#2f2e41;}.f{fill:#d5997f;}.g{fill:#fff;}.h{fill:#cfcce0;}.i{fill:#006384;}.j{fill:#66e4ee;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-451.573 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(451.573 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 84.44,
    cy: 84.44,
    r: 84.44,
    transform: "translate(12.1 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M242.286,764.278s64.751-21.625,142.94,0",
    transform: "translate(-242.286 -591.278)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455.802 49.269)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M170.952,546.408l-1.373-5.415a70.314,70.314,0,0,0-7.46-2.676l-.173,2.517-.7-2.773c-3.144-.9-5.283-1.293-5.283-1.293s2.889,10.986,8.948,19.385l7.061,1.24-5.485.791a28.448,28.448,0,0,0,2.454,2.6c8.815,8.182,18.633,11.936,21.929,8.385s-1.177-13.063-9.992-21.245a37.453,37.453,0,0,0-9.6-6.174Z",
    transform: "translate(-155.96 -437.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M235.055,505.216l1.624-5.345a70.312,70.312,0,0,0-5-6.147l-1.449,2.065.831-2.737c-2.227-2.394-3.854-3.838-3.854-3.838s-3.206,10.9-2.36,21.22l5.4,4.711-5.1-2.158a28.444,28.444,0,0,0,.756,3.494c3.317,11.561,9.781,19.849,14.438,18.513s5.745-11.791,2.428-23.352a37.451,37.451,0,0,0-5.028-10.248Z",
    transform: "translate(-207.006 -402.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.967,11.575,5.792,7.709A50.863,50.863,0,0,1,9.411,3.262L10.46,4.756l-.6-1.98C11.469,1.045,12.646,0,12.646,0a48.746,48.746,0,0,1,1.707,15.35l-3.908,3.408L14.137,17.2a20.581,20.581,0,0,1-.547,2.528c-2.4,8.362-7.075,14.358-10.444,13.392S-1.01,24.586,1.389,16.224A27.092,27.092,0,0,1,5.026,8.81Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 115.687, 100.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M278.9,431.514s-1.78,21.406-2.163,25.993a32.62,32.62,0,0,1-1.911,8.409,7.907,7.907,0,0,0-.764,3.058v19.494A1.136,1.136,0,0,0,272.913,490c.382,1.529.764,4.2.764,4.2h5.734a1.184,1.184,0,0,1,.764-1.529c1.147-.382,0-3.44,0-3.44l6.116-22.934,9.174-19.112s5.351,17.2,6.5,19.112c0,0,4.2,21.405,4.969,23.317s1.147,1.911.764,2.676a1.706,1.706,0,0,0,0,1.911c.382.382,7.645,0,7.645,0l-1.911-27.139-3.44-32.49-17.583-5.351Z",
    transform: "translate(-223.966 -365.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M264.234,659.465s-1.911-6.88-4.969-1.529-3.058,7.263-3.058,7.263-4.969,7.263,1.911,6.5,5.351-4.2,5.351-4.2,2.676-1.529,2.676-2.676S264.234,659.465,264.234,659.465Z",
    transform: "translate(-210.318 -534.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M407.146,656.5s1.911-6.88,4.969-1.529,3.058,7.263,3.058,7.263,4.969,7.263-1.911,6.5-5.351-4.2-5.351-4.2-2.676-1.529-2.676-2.676S407.146,656.5,407.146,656.5Z",
    transform: "translate(-322.268 -531.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M337.186,237.686s.764,4.969-1.529,6.116,4.969,5.351,6.88,5.351,5.351-3.822,5.351-3.822-1.911-5.734-1.529-6.88Z",
    transform: "translate(-270.274 -223.482)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.027,
    cy: 8.027,
    r: 8.027,
    transform: "translate(63.09 1.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M327.069,266.455l-9.556-5.789s-5.437,6.172-11.319-.709l-10.087,2.676,1.529,25.992s-2.293,10.32-1.529,12.232-1.911,2.676-1.147,3.058,0,3.058,0,3.058,14.907,7.645,31.344,1.911l-1.529-4.969a4.011,4.011,0,0,0-.764-3.822,3.382,3.382,0,0,0-.382-4.2s.764-3.44-1.147-4.969l-.382-5.351,1.147-2.676Z",
    transform: "translate(-240.28 -240.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M330.694,188.786s-.957,2.071,2.871,1.243c0,0,1.436.828,1.436-.414,0,0,1.914,2.071,2.392.828s1.436.414,1.436.414l.957-2.071.957,1.243h3.349s.957-8.284-10.527-7.456-5.834,13.954-5.834,13.954.092-2.356,1.049-1.113S330.694,188.786,330.694,188.786Z",
    transform: "translate(-263.685 -182.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M412.739,344.589l.382,8.027s1.529,14.907-1.529,21.405v3.44s-.764,8.792-4.587,8.409,1.147-12.614,1.147-12.614l-.764-16.819-.764-9.556Z",
    transform: "translate(-322.51 -302.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M393.827,284.9l3.813-.62A18.616,18.616,0,0,1,403,294.07c1.147,6.116,1.529,7.263,1.529,7.263l-9.174,2.293-4.969-9.556Z",
    transform: "translate(-311.243 -258.079)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 60.321,
    height: 29.965,
    transform: "translate(60.019 31.852) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M11.865,0H2.179a2.179,2.179,0,0,0,0,4.359h9.686a2.179,2.179,0,0,0,0-4.359Z",
    transform: "translate(66.873 51.059) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M59.116,0H4.81A4.811,4.811,0,0,0,0,4.81V31.269A4.811,4.811,0,0,0,4.811,36.08H59.116a4.811,4.811,0,0,0,4.811-4.811V4.81A4.811,4.811,0,0,0,59.116,0ZM3.467,3.281A7.6,7.6,0,0,1,8.223,4.1a7.6,7.6,0,0,1,2.948,3.82l.085.264-.273.048A7.255,7.255,0,0,1,9.8,8.315a7.017,7.017,0,0,1-3.577-.9,7.6,7.6,0,0,1-2.948-3.82L3.194,3.33ZM15.255,27.847H5.569a2.664,2.664,0,1,1,0-5.327h9.686a2.664,2.664,0,0,1,0,5.327Zm44.07-.484a2.914,2.914,0,0,1-2.906,2.906H49.156a2.914,2.914,0,0,1-2.906-2.906V23A2.914,2.914,0,0,1,49.156,20.1H56.42A2.914,2.914,0,0,1,59.326,23Z",
    transform: "translate(58.019 29.559) rotate(-14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 9,
    height: 8,
    transform: "translate(64.483 29.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M4,0H.848a.848.848,0,1,0,0,1.7H4A.848.848,0,1,0,4,0ZM4,1.211H.848a.363.363,0,1,1,0-.726H4a.363.363,0,1,1,0,.726Z",
    transform: "translate(110.484 43.804) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M4,0H.848a.848.848,0,0,0,0,1.7H4A.848.848,0,0,0,4,0ZM4,1.211H.848a.363.363,0,1,1,0-.726H4a.363.363,0,0,1,0,.726Z",
    transform: "translate(116.123 42.398) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M4,0H.848a.848.848,0,1,0,0,1.7H4A.848.848,0,1,0,4,0ZM4,1.211H.848a.363.363,0,1,1,0-.726H4a.363.363,0,1,1,0,.726Z",
    transform: "translate(109.957 41.69) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M4,0H.848a.848.848,0,0,0,0,1.7H4A.848.848,0,0,0,4,0ZM4,1.211H.848a.363.363,0,1,1,0-.726H4a.363.363,0,0,1,0,.726Z",
    transform: "translate(115.596 40.284) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M4,0H.848a.848.848,0,1,0,0,1.7H4A.848.848,0,1,0,4,0ZM4,1.211H.848a.363.363,0,1,1,0-.726H4a.363.363,0,1,1,0,.726Z",
    transform: "translate(109.43 39.575) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M4,0H.848a.848.848,0,0,0,0,1.7H4A.848.848,0,0,0,4,0ZM4,1.211H.848a.363.363,0,1,1,0-.726H4a.363.363,0,0,1,0,.726Z",
    transform: "translate(115.068 38.169) rotate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M273.722,299.049s-3.44,14.525.764,14.525,14.143-16.436,14.143-16.436,10.32-5.351,6.116-7.263-9.556,3.058-9.556,3.058l-6.175,8.573-.323-4.368Z",
    transform: "translate(-223.628 -261.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M281.161,272.644l-2.293-2.293s-4.587,2.676-4.969,5.351-2.293,11.085-2.293,11.085l7.071.573,2.293-3.44Z",
    transform: "translate(-223.041 -247.738)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 23.522,
    cy: 23.522,
    rx: 23.522,
    ry: 23.522,
    transform: "translate(593.393 115.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M74,84.32,67.146,75.51l3.985-3.1,3.245,4.172L85.337,65.011,89,68.484Z",
    transform: "translate(540.735 64.378)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCreditCard);
export default __webpack_public_path__ + "static/media/user-credit-card.48fa3b34e8971d72868febedcbd142b6.svg";
export { ForwardRef as ReactComponent };